import "./learningLibrary/learningLibrary.scss";

//Check on resize to see if the buttons have wrapper, if so, make 100% width
const moduleCards = document.querySelectorAll(".moduleCard");

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const buttons = entry.target.querySelectorAll(".moduleCard__button");

    //get top offsets for each button
    const topOffsets = Array.from(buttons).map((button) => button.offsetTop);

    //check if the offsets are all equal
    if (topOffsets.every((i) => i === topOffsets[0])) {
      //if on the same line, remove 'stretch' class
      buttons.forEach((b) => b.classList.remove("moduleCard__button--stretch"));
    } else {
      //otherwise, when wrapping, add it
      buttons.forEach((b) => b.classList.add("moduleCard__button--stretch"));
    }
  }
});

moduleCards.forEach((el) => {
  resizeObserver.observe(el);
});
